module.exports = __webpack_public_path__ + "img/SEA-PEARL-LOGO.212573ce.jpg";